/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./client/app/scripts/application/ecom.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./client/app/scripts/application/ecom.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./node_modules/vt-frontend-engine/app/scripts/components/footer-accordion.js");

__webpack_require__("./node_modules/vt-frontend-engine/app/scripts/components/footer-collapsible.js");

__webpack_require__("./node_modules/vt-frontend-engine/app/scripts/components/nav-search.js");

__webpack_require__("./node_modules/vt-frontend-engine/app/scripts/components/site-nav.js");

__webpack_require__("./node_modules/vt-frontend-engine/app/scripts/components/top-bar.js");

/***/ }),

/***/ "./node_modules/vt-frontend-engine/app/scripts/basics/accordion.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


function Accordion($accordion) {
  this.$accordion = $accordion;
  this.$tabs = this.$accordion.find('[role="tab"]');
  this.$panels = this.$accordion.find('[role="tabpanel"]');
  this.setup();
}

Accordion.prototype = {
  setup: function setup() {
    var constructor = this;

    this.$accordion.on('click', '[role="tab"]', function () {
      var $tab = $(this),
          state = $tab.is('[aria-expanded="true"]') ? 'close' : 'open';

      constructor.setPanelState(state, $tab);
    }).on('keydown', function (e) {
      constructor.onKeydown(e);
    });

    this.setPanelState('close');
  },

  teardown: function teardown() {
    this.setPanelState('open');

    this.$accordion.off('click', '[role="tab"]').off('keydown');
  },

  setPanelState: function setPanelState(state, $tab) {
    var $panel = $tab ? this.getRelatedPanel($tab) : this.$panels;

    $tab = $tab || this.$tabs;
    state = state === 'open' ? 'true' : 'false';

    $tab.attr({
      'aria-expanded': state,
      'aria-selected': state
    });

    $panel.attr({
      'aria-expanded': state
    });
  },

  onKeydown: function onKeydown(e) {
    var $target = $(e.target),
        $tabDestination,
        isModified = e.altKey || e.ctrlKey || e.shiftKey,
        isDownArrow = e.keyCode === 40,
        isLeftArrow = e.keyCode === 37,
        isRightArrow = e.keyCode === 39,
        isUpArrow = e.keyCode === 38,
        isTabFocused = $target.attr('role') === 'tab',
        tabDestination,
        tabIndex;

    if (isTabFocused && !isModified && (isDownArrow || isLeftArrow || isRightArrow || isUpArrow)) {
      tabIndex = this.$tabs.index($target);
      tabDestination = tabIndex;

      if ((isUpArrow || isLeftArrow) && tabIndex > 0) {
        tabDestination = tabIndex - 1;
      }

      if ((isDownArrow || isRightArrow) && tabIndex < this.$tabs.length - 1) {
        tabDestination = tabIndex + 1;
      }

      if (tabDestination !== tabIndex) {
        $tabDestination = this.$tabs.eq(tabDestination);
        $tabDestination.focus();
        e.preventDefault();
      }
    }
  },

  getRelatedPanel: function getRelatedPanel($tab) {
    return this.$panels.filter('#' + $tab.attr('aria-controls'));
  }
};

exports.default = Accordion;

/***/ }),

/***/ "./node_modules/vt-frontend-engine/app/scripts/components/footer-accordion.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _accordion = __webpack_require__("./node_modules/vt-frontend-engine/app/scripts/basics/accordion.js");

var _accordion2 = _interopRequireDefault(_accordion);

var _debounce = __webpack_require__("./node_modules/vt-frontend-engine/app/scripts/principles/performance/debounce.js");

var _debounce2 = _interopRequireDefault(_debounce);

var _matchViewport = __webpack_require__("./node_modules/vt-frontend-engine/app/scripts/principles/responsive/match-viewport.js");

var _matchViewport2 = _interopRequireDefault(_matchViewport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {

  var accordion,
      $footer = $('.site-footer'),
      $accordionHeadings = $footer.find('\n    .site-footer__top .site-footer__heading,\n    .site-footer-set--about-resources .site-footer__heading,\n    .site-footer-set--about-company .site-footer__heading'),
      isSetup = false,
      init = function init() {
    if ((0, _matchViewport2.default)('width-l')) {
      teardown();
    } else {
      setup();
    }
  },
      moveAttributes = function moveAttributes(attributes, $source, $target) {
    $.each(attributes, function (index, value) {
      var attribute = value;

      value = $source.attr(value);
      $source.removeAttr(attribute);
      $target.attr(attribute, value);
    });
  },
      setup = function setup() {
    if (!isSetup) {
      isSetup = true;

      $.each($accordionHeadings, function (index, value) {
        var $heading = $(value);
        $heading.wrap('<button/>');
        moveAttributes(['aria-controls', 'id', 'role'], $heading, $heading.parent('button'));
      });

      accordion = new _accordion2.default($footer);
    }
  },
      teardown = function teardown() {
    if (isSetup) {
      isSetup = false;
      accordion.teardown();

      $.each($accordionHeadings, function (index, value) {
        var $heading = $(value);
        moveAttributes(['aria-controls', 'id', 'role'], $heading.parent('button'), $heading);
        $heading.unwrap('<button/>');
      });
    }
  };

  init();
  $(window).on('resize', (0, _debounce2.default)(init, 250));
})();

/***/ }),

/***/ "./node_modules/vt-frontend-engine/app/scripts/components/footer-collapsible.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _debounce = __webpack_require__("./node_modules/vt-frontend-engine/app/scripts/principles/performance/debounce.js");

var _debounce2 = _interopRequireDefault(_debounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$('.js-site-footer--legal__notes-trigger').click(function () {
  $('.site-footer--legal__notes').toggle(0, function () {
    $('html, body').animate({ scrollTop: $(document).height() }, 'fast');
  });
  $('.js-show-site-footer--legal__notes, .js-hide-site-footer--legal__notes').toggle();
});

(function () {
  var $footerShowMoreTrigger = $('.js-footer__show-more--trigger');
  var $siteFooterContainer = $('.site-footer__container');
  var $cachedWidth = $(window).width();

  $footerShowMoreTrigger.on('click', function () {
    $footerShowMoreTrigger.text($(this).text() == 'Show Less' ? 'Show More' : 'Show Less');
    $('.site-footer__container').toggle();
  });

  var handleResize = function handleResize() {
    var $newWidth = $(window).width();
    if ($newWidth !== $cachedWidth) {
      $cachedWidth = $newWidth;

      $siteFooterContainer.removeAttr('style');
      $footerShowMoreTrigger.text('Show More');
    }
  };

  $(window).on('resize', (0, _debounce2.default)(handleResize, 250));
})();

/***/ }),

/***/ "./node_modules/vt-frontend-engine/app/scripts/components/nav-search.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _autoComplete = __webpack_require__("./node_modules/vt-frontend-engine/app/scripts/features/auto-complete.js");

var _autoComplete2 = _interopRequireDefault(_autoComplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavSearch = {
  create: function create(identifier) {
    var _this = this;

    var self = this;
    var componentSelector = '.nav-search--' + identifier;
    var component = $(componentSelector);
    var inputSelector = componentSelector + ' .nav-search__input';
    var menuClass = 'nav-search__menu nav-search__menu--' + identifier;
    var dataFromMarkup = component.data();
    $(inputSelector).on('focus', function (e) {
      _this.adjustMenuHeight(e);
    });

    new _autoComplete2.default({
      selector: inputSelector,
      minChars: 3,
      menuClass: menuClass,
      source: function source(term, suggestions) {
        self.sourceData(dataFromMarkup, term, suggestions);
      },
      renderItem: function renderItem(item, search) {
        var label = item.display_name || item.name + ', ' + item.state;
        return '<a rel="nofollow" class="autocomplete-suggestion nav-search__menu-item"\n                   href="' + self.buildMenuLink(dataFromMarkup, item) + '">' + label + '</a>';
      },
      onSelect: function onSelect(e, term, item) {
        window.location.href = item.href;
      }
    });
  },
  buildMenuLink: function buildMenuLink(dataFromMarkup, item) {
    var possibleLocale = dataFromMarkup.locale ? dataFromMarkup.locale + '-' : '';

    var href = item.short_name_unique ? '/tutoring-' + item.short_name_unique : '/' + possibleLocale + item.short_name + '-tutoring';
    return href;
  },
  sourceData: function sourceData(dataFromMarkup, term, suggestions) {
    term = term.toLowerCase();


    $.getJSON('/' + dataFromMarkup.apiEndpoint + '/lookup', { query: term }, function (data) {
      $('.nav-search__menu').hide();
      suggestions(data);
    });
  },


  adjustMenuHeight: function adjustMenuHeight(e) {
    var parentMenu = $(e.target).closest('.site-nav__menu');
    var label = parentMenu.attr('id').replace('menu-', '');
    var height = parentMenu.height();
    $('.nav-search__menu--' + label).css({ maxHeight: height - 100 });
  }
};

$(function () {
  NavSearch.create('locations');
  NavSearch.create('test-prep');
  NavSearch.create('academic-tutoring');
});

/***/ }),

/***/ "./node_modules/vt-frontend-engine/app/scripts/components/site-nav.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _debounce = __webpack_require__("./node_modules/vt-frontend-engine/app/scripts/principles/performance/debounce.js");

var _debounce2 = _interopRequireDefault(_debounce);

var _matchViewport = __webpack_require__("./node_modules/vt-frontend-engine/app/scripts/principles/responsive/match-viewport.js");

var _matchViewport2 = _interopRequireDefault(_matchViewport);

var _throttle = __webpack_require__("./node_modules/vt-frontend-engine/app/scripts/principles/performance/throttle.js");

var _throttle2 = _interopRequireDefault(_throttle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var $html = $('html'),
      $navControl = $('.site-nav-control'),
      $navOverlay = $('.offscreen-overlay'),
      $nav = $('.site-nav'),
      $navContainer = $('.site-nav__container'),
      $navMenus = $nav.find('.site-nav__menu'),
      $navSubmenus = $nav.find('.site-nav__submenu'),
      $navSearchInputs = $('.nav-search__input'),
      $window = $(window),
      offscreenNavOpenClass = 'offscreen-nav-open',
      fullNavOpenClass = 'full-nav-open',
      containerMenuOpenClass = 'site-nav__container--menu-is-open',
      containerSubmenuOpenClass = 'site-nav__container--submenu-is-open',
      activeParentClass = 'site-nav__link--menu-parent-active',
      menuOpenClass = 'site-nav__menu--is-open',
      transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend',
      menuTimeout = 250,
      getRelatedMenu = function getRelatedMenu($link) {
    return $('#' + $link.attr('aria-controls'));
  },
      init = function init() {
    if ((0, _matchViewport2.default)('width-xxl')) {
      fullNav.setup();
      offscreenNav.teardown();
    } else {
      fullNav.teardown();
      offscreenNav.setup();
    }
  },
      offscreenNav = {
    isOpen: false,
    isSetup: false,

    close: function close() {
      if (!offscreenNav.isOpen) {
        return;
      }

      offscreenNav.isOpen = false;
      $html.removeClass(offscreenNavOpenClass);
    },

    open: function open() {
      if (offscreenNav.isOpen) {
        return;
      }

      offscreenNav.isOpen = true;
      $html.addClass(offscreenNavOpenClass);
    },

    setup: function setup() {
      if (offscreenNav.isSetup) {
        return;
      }

      offscreenNav.isSetup = true;

      $navControl.on('click.offscreen-nav', function () {
        if (offscreenNav.isOpen) {
          offscreenNav.close();
        } else {
          offscreenNav.open();
        }
      });

      $navOverlay.on('click.offscreen-overlay', offscreenNav.close);

      $html.on(transitionEnd, function () {
        if (!offscreenNav.isOpen) {
          offscreenNav.closeMenu();
          offscreenNav.closeSubmenu();

          $nav.find('.' + menuOpenClass).removeClass(menuOpenClass);
        }
      });

      offscreenNav.setupMenus();
    },

    teardown: function teardown() {
      if (!offscreenNav.isSetup) {
        return;
      }

      offscreenNav.isSetup = false;

      if (offscreenNav.isOpen) {
        $navOverlay.trigger('click');
      }

      $navControl.off('click.offscreen-nav');
      $navOverlay.off('click.offscreen-overlay');
      $html.off(transitionEnd);

      offscreenNav.teardownMenus();
    },

    isMenuOpen: false,

    closeMenu: function closeMenu() {
      offscreenNav.isMenuOpen = false;
      $navContainer.removeClass(containerMenuOpenClass);
    },

    closeSubmenu: function closeSubmenu() {
      $navContainer.removeClass(containerSubmenuOpenClass);
    },

    menuClosed: function menuClosed() {
      $navMenus.removeClass(menuOpenClass);
    },

    openMenu: function openMenu($link) {
      offscreenNav.isMenuOpen = true;
      $navContainer.addClass(containerMenuOpenClass);
      getRelatedMenu($link).addClass(menuOpenClass);
    },

    openSubmenu: function openSubmenu($link) {
      $navContainer.addClass(containerSubmenuOpenClass);
      $navSubmenus.removeClass(menuOpenClass);
      getRelatedMenu($link).addClass(menuOpenClass);
    },

    setupMenus: function setupMenus() {
      $nav.on('click.offscreen-nav-link', '.site-nav__link--menu-parent', function () {
        offscreenNav.openMenu($(this));
        return false;
      });

      $nav.on('click.offscreen-nav-link', '.site-nav__link--submenu-parent', function () {
        offscreenNav.openSubmenu($(this));
        return false;
      });

      $nav.on('click.offscreen-nav-back', '.site-nav__back', function () {
        if ($(this).hasClass('site-nav__back--submenu')) {
          offscreenNav.closeSubmenu();
        } else {
          offscreenNav.closeMenu();
        }
      });

      $navContainer.on(transitionEnd, function () {
        if (!offscreenNav.isMenuOpen) {
          offscreenNav.menuClosed();
        }
      });
    },

    teardownMenus: function teardownMenus() {
      $nav.off('click.offscreen-nav-link');
      $nav.off('click.offscreen-nav-back');
      $navContainer.off(transitionEnd);
    }
  },
      fullNav = {
    isSetup: false,

    closeMenu: function closeMenu($menu, closeAll) {
      var $context = closeAll ? $navMenus : $menu;
      $context.removeClass(menuOpenClass);
      $('.site-nav__link').removeClass(activeParentClass);
      $navSearchInputs.blur();
      $('.nav-search__menu').hide();
    },

    openMenu: function openMenu($menu, $link) {
      setTimeout(function () {
        if ($menu.data('isHovering')) {
          fullNav.closeMenu($menu, true);
          $menu.addClass(menuOpenClass);
          $link.addClass(activeParentClass);
        }
      }, menuTimeout);
    },

    setup: function setup() {

      if (fullNav.isSetup) {
        return;
      }

      var hasPendingTouch = false,
          isHoveringInMenu = false;

      fullNav.isSetup = true;

      $nav.on('touchstart.full-nav-link', '.site-nav__link--menu-parent', function () {

        hasPendingTouch = true;

        $window.on('scroll.full-nav-link', (0, _throttle2.default)(function () {
          hasPendingTouch = false;
        }, 250));
      }).on('touchend.full-nav-link', '.site-nav__link--menu-parent', function (e) {
        e.preventDefault();

        var $link = $(this);

        $window.off('scroll.full-nav-link');

        if (hasPendingTouch === true) {

          var $relatedMenu = getRelatedMenu($link),
              isMenuOpen = $relatedMenu.hasClass(menuOpenClass);

          isMenuOpen ? fullNav.closeMenu($relatedMenu) : fullNav.openMenu($relatedMenu, $link);
        }
      }).on('focusin.full-nav-link\n           mouseenter.full-nav-link', '.site-nav__link--menu-parent', function () {
        var $link = $(this);
        getRelatedMenu($link).data('isHovering', true);
        fullNav.openMenu(getRelatedMenu($link), $link);
      }).on('mouseleave.full-nav-link', '.site-nav__link--menu-parent', function () {
        var $link = $(this);
        getRelatedMenu($link).data('isHovering', false);

        window.setTimeout(function () {
          isHoveringInMenu = $html.hasClass(fullNavOpenClass);

          if (!isHoveringInMenu) {
            fullNav.closeMenu(getRelatedMenu($link));
          }
        }, 50);
      }).on('click.full-nav-link', '.site-nav__link--menu-parent', function (e) {
        e.preventDefault();
      });

      $navMenus.on('mouseenter.full-nav-link', function () {
        $html.addClass(fullNavOpenClass);
      }).on('mouseleave.full-nav-link', function (e) {
        if ($(e.target).closest('.nav-search').length > 0) {
          return;
        }

        fullNav.closeMenu('', true);
        $html.removeClass(fullNavOpenClass);
      });

      $html.on('click.full-nav-menu', function (e) {

        var isMenuChild,
            isSearchBox,
            isMenuOpen = $navMenus.filter('.' + menuOpenClass).length > 0;

        if (isMenuOpen) {
          isMenuChild = $(e.target).closest('.site-nav__menu').length > 0;
          isSearchBox = $(e.target).closest('.nav-search').length > 0;

          if (!isMenuChild && !isSearchBox) {
            fullNav.closeMenu(null, true);
          }
        }
      });
    },

    teardown: function teardown() {
      if (!fullNav.isSetup) {
        return;
      }

      fullNav.isSetup = false;

      $nav.off('\n        click.full-nav-link\n        focusin.full-nav-link\n        mouseenter.full-nav-link\n        mouseleave.full-nav-link\n        touchstart.full-nav-link\n        touchend.full-nav-link');
      $navMenus.off('\n        mouseenter.full-nav-link\n        mouseleave.full-nav-link');
      $html.off('click.full-nav-menu');
    }
  };

  init();
  $(window).on('resize', (0, _debounce2.default)(init, 250));
})();

/***/ }),

/***/ "./node_modules/vt-frontend-engine/app/scripts/components/top-bar.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _debounce = __webpack_require__("./node_modules/vt-frontend-engine/app/scripts/principles/performance/debounce.js");

var _debounce2 = _interopRequireDefault(_debounce);

var _matchViewport = __webpack_require__("./node_modules/vt-frontend-engine/app/scripts/principles/responsive/match-viewport.js");

var _matchViewport2 = _interopRequireDefault(_matchViewport);

var _requestAnimationFrame = __webpack_require__("./node_modules/vt-frontend-engine/app/scripts/principles/performance/requestAnimationFrame.js");

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var $html = $('html'),
      isEnabled = false,
      isScrolledClass = 'is-scrolled',
      disableAnimation = function disableAnimation() {
    if (!isEnabled) {
      return;
    }

    isEnabled = false;
    $html.removeClass(isScrolledClass);
  },
      enableAnimation = function enableAnimation() {
    if (isEnabled) {
      return;
    }

    isEnabled = true;
    handleOffset();

    $(window).on('scroll', function () {
      (0, _requestAnimationFrame2.default)(handleOffset);
    });
  },
      handleOffset = function handleOffset() {
    if ((0, _matchViewport2.default)('width-xxl')) {
      return;
    }

    $html[(window.pageYOffset > 0 ? 'add' : 'remove') + 'Class'](isScrolledClass);
  },
      init = function init() {
    if ((0, _matchViewport2.default)('width-xxl')) {
      disableAnimation();
    } else {
      enableAnimation();
    }
  };

  init();
  $(window).on('resize', (0, _debounce2.default)(init, 250));
})();

/***/ }),

/***/ "./node_modules/vt-frontend-engine/app/scripts/features/auto-complete.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var autoComplete = function () {
    function autoComplete(options) {
        if (!document.querySelector) return;

        function hasClass(el, className) {
            return el.classList ? el.classList.contains(className) : new RegExp('\\b' + className + '\\b').test(el.className);
        }

        function addEvent(el, type, handler) {
            if (el.attachEvent) el.attachEvent('on' + type, handler);else el.addEventListener(type, handler);
        }
        function removeEvent(el, type, handler) {
            if (el.detachEvent) el.detachEvent('on' + type, handler);else el.removeEventListener(type, handler);
        }
        function live(elClass, event, cb, context) {
            addEvent(context || document, event, function (e) {
                var found,
                    el = e.target || e.srcElement;
                while (el && !(found = hasClass(el, elClass))) {
                    el = el.parentElement;
                }if (found) cb.call(el, e);
            });
        }

        var o = {
            selector: 0,
            source: 0,
            minChars: 3,
            delay: 150,
            offsetLeft: 0,
            offsetTop: 1,
            cache: 1,
            menuClass: '',
            renderItem: function renderItem(item, search) {
                search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
                var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
                return '<div class="autocomplete-suggestion" data-val="' + item + '">' + item.replace(re, "<b>$1</b>") + '</div>';
            },
            onSelect: function onSelect(e, term, item) {}
        };
        for (var k in options) {
            if (options.hasOwnProperty(k)) o[k] = options[k];
        }

        var elems = _typeof(o.selector) == 'object' ? [o.selector] : document.querySelectorAll(o.selector);
        for (var i = 0; i < elems.length; i++) {
            var that = elems[i];

            that.sc = document.createElement('div');
            that.sc.className = 'autocomplete-suggestions ' + o.menuClass;

            that.autocompleteAttr = that.getAttribute('autocomplete');
            that.setAttribute('autocomplete', 'off');
            that.cache = {};
            that.last_val = '';

            that.updateSC = function (resize, next) {
                var rect = that.getBoundingClientRect();
                that.sc.style.left = Math.round(window.offsetLeft) + 'px';
                that.sc.style.top = Math.round(window.offsetTop) + 'px';
                that.sc.style.width = Math.round(rect.right - rect.left) + 'px';
                if (!resize) {
                    that.sc.style.display = 'block';
                    if (!that.sc.maxHeight) {
                        that.sc.maxHeight = parseInt((window.getComputedStyle ? getComputedStyle(that.sc, null) : that.sc.currentStyle).maxHeight);
                    }
                    if (!that.sc.suggestionHeight) that.sc.suggestionHeight = that.sc.querySelector('.autocomplete-suggestion').offsetHeight;
                    if (that.sc.suggestionHeight) if (!next) that.sc.scrollTop = 0;else {
                        var scrTop = that.sc.scrollTop,
                            selTop = next.getBoundingClientRect().top - that.sc.getBoundingClientRect().top;
                        if (selTop + that.sc.suggestionHeight - that.sc.maxHeight > 0) that.sc.scrollTop = selTop + that.sc.suggestionHeight + scrTop - that.sc.maxHeight;else if (selTop < 0) that.sc.scrollTop = selTop + scrTop;
                    }
                }
            };
            addEvent(window, 'resize', that.updateSC);
            that.parentNode.appendChild(that.sc);

            live('autocomplete-suggestion', 'mouseleave', function (e) {
                var sel = that.sc.querySelector('.autocomplete-suggestion.selected');
                if (sel) setTimeout(function () {
                    sel.className = sel.className.replace('selected', '');
                }, 20);
            }, that.sc);

            live('autocomplete-suggestion', 'mouseover', function (e) {
                var sel = that.sc.querySelector('.autocomplete-suggestion.selected');
                if (sel) sel.className = sel.className.replace('selected', '');
                this.className += ' selected';
            }, that.sc);

            live('autocomplete-suggestion', 'mousedown', function (e) {
                if (hasClass(this, 'autocomplete-suggestion')) {
                    var v = this.getAttribute('data-val');
                    that.value = v;
                    o.onSelect(e, v, this);
                    that.sc.style.display = 'none';
                }
            }, that.sc);

            that.blurHandler = function () {
                try {
                    var over_sb = document.querySelector('.autocomplete-suggestions:hover');
                } catch (e) {
                    var over_sb = 0;
                }
                if (!over_sb) {
                    that.last_val = that.value;
                    that.sc.style.display = 'none';
                    setTimeout(function () {
                        that.sc.style.display = 'none';
                    }, 350);
                } else if (that !== document.activeElement) setTimeout(function () {
                    that.focus();
                }, 20);
            };
            addEvent(that, 'blur', that.blurHandler);

            var suggest = function suggest(data) {
                var val = that.value;
                that.cache[val] = data;
                if (data.length && val.length >= o.minChars) {
                    var s = '';
                    for (var i = 0; i < data.length; i++) {
                        s += o.renderItem(data[i], val);
                    }that.sc.innerHTML = s;
                    that.updateSC(0);
                } else that.sc.style.display = 'none';
            };

            that.keydownHandler = function (e) {
                var key = window.event ? e.keyCode : e.which;

                if ((key == 40 || key == 38) && that.sc.innerHTML) {
                    var next,
                        sel = that.sc.querySelector('.autocomplete-suggestion.selected');
                    if (!sel) {
                        next = key == 40 ? that.sc.querySelector('.autocomplete-suggestion') : that.sc.childNodes[that.sc.childNodes.length - 1];
                        next.className += ' selected';
                        that.value = next.getAttribute('data-val');
                    } else {
                        next = key == 40 ? sel.nextSibling : sel.previousSibling;
                        if (next) {
                            sel.className = sel.className.replace('selected', '');
                            next.className += ' selected';
                            that.value = next.getAttribute('data-val');
                        } else {
                            sel.className = sel.className.replace('selected', '');that.value = that.last_val;next = 0;
                        }
                    }
                    that.updateSC(0, next);
                    return false;
                } else if (key == 27) {
                        that.value = that.last_val;that.sc.style.display = 'none';
                    } else if (key == 13 || key == 9) {
                            var sel = that.sc.querySelector('.autocomplete-suggestion.selected');
                            if (sel && that.sc.style.display != 'none') {
                                o.onSelect(e, sel.getAttribute('data-val'), sel);setTimeout(function () {
                                    that.sc.style.display = 'none';
                                }, 20);
                            }
                        }
            };
            addEvent(that, 'keydown', that.keydownHandler);

            that.keyupHandler = function (e) {
                var key = window.event ? e.keyCode : e.which;
                if (!key || (key < 35 || key > 40) && key != 13 && key != 27) {
                    var val = that.value;
                    if (val.length >= o.minChars) {
                        if (val != that.last_val) {
                            that.last_val = val;
                            clearTimeout(that.timer);
                            if (o.cache) {
                                if (val in that.cache) {
                                    suggest(that.cache[val]);return;
                                }

                                for (var i = 1; i < val.length - o.minChars; i++) {
                                    var part = val.slice(0, val.length - i);
                                    if (part in that.cache && !that.cache[part].length) {
                                        suggest([]);return;
                                    }
                                }
                            }
                            that.timer = setTimeout(function () {
                                o.source(val, suggest);
                            }, o.delay);
                        }
                    } else {
                        that.last_val = val;
                        that.sc.style.display = 'none';
                    }
                }
            };
            addEvent(that, 'keyup', that.keyupHandler);

            that.focusHandler = function (e) {
                that.last_val = '\n';
                that.keyupHandler(e);
            };
            if (!o.minChars) addEvent(that, 'focus', that.focusHandler);
        }

        this.destroy = function () {
            for (var i = 0; i < elems.length; i++) {
                var that = elems[i];
                removeEvent(window, 'resize', that.updateSC);
                removeEvent(that, 'blur', that.blurHandler);
                removeEvent(that, 'focus', that.focusHandler);
                removeEvent(that, 'keydown', that.keydownHandler);
                removeEvent(that, 'keyup', that.keyupHandler);
                if (that.autocompleteAttr) that.setAttribute('autocomplete', that.autocompleteAttr);else that.removeAttribute('autocomplete');
                document.body.removeChild(that.sc);
                that = null;
            }
        };
    }
    return autoComplete;
}();

(function () {
    if (true) !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
        return autoComplete;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if (typeof module !== 'undefined' && module.exports) module.exports = autoComplete;else window.autoComplete = autoComplete;
})();

/***/ }),

/***/ "./node_modules/vt-frontend-engine/app/scripts/principles/performance/debounce.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _debounce;
function _debounce(fn, delay) {
  var executeImmediately = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;


  var timeout;

  if (typeof fn !== 'function') {
    throw new TypeError('debounce: The debounce method expects the fn argument to be a function');
  }

  function later(args) {
    timeout = null;

    if (!executeImmediately) {
      fn.apply(this, args);
    }
  }

  return function () {

    if (executeImmediately && !timeout) {
      fn.apply(this, arguments);
    }

    if (timeout) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(later.bind(this, arguments), delay);
  };
}

/***/ }),

/***/ "./node_modules/vt-frontend-engine/app/scripts/principles/performance/requestAnimationFrame.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (callback) {
    window.setTimeout(callback, 1000 / 60);
  };
}();

/***/ }),

/***/ "./node_modules/vt-frontend-engine/app/scripts/principles/performance/throttle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _throttle;
function _throttle(fn, delay) {
  var executeImmediately = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var allowTrailingExecution = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;


  var previous = 0;
  var context;
  var args;
  var result;
  var timeout;

  function later() {
    previous = !executeImmediately ? 0 : new Date().getTime();
    timeout = null;
    result = fn.apply(context, args);

    if (!timeout) {
      context = args = null;
    }
  }

  return function () {

    var now = new Date().getTime();

    var remaining = delay - (now - previous);

    if (!previous && !executeImmediately) {
      previous = now;
    }

    context = this;
    args = arguments;

    if (remaining <= 0 || remaining > delay) {

      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }

      previous = now;
      result = fn.apply(context, args);

      if (!timeout) {
        context = args = null;
      }
    } else if (!timeout && allowTrailingExecution) {
      timeout = setTimeout(later, remaining);
    }

    return result;
  };
}

/***/ }),

/***/ "./node_modules/vt-frontend-engine/app/scripts/principles/responsive/breakpoints.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  breakpoints: {
    height: {
      s: "'" + 320 / 16 + "em'",
      m: "'" + 460 / 16 + "em'",
      l: "'" + 600 / 16 + "em'",
      xl: "'" + 750 / 16 + "em'",
      xxl: "'" + 900 / 16 + "em'"
    },
    width: {
      xxs: "'" + 240 / 16 + "em'",
      xs: "'" + 300 / 16 + "em'",
      s: "'" + 440 / 16 + "em'",
      m: "'" + 600 / 16 + "em'",
      l: "'" + 750 / 16 + "em'",
      xl: "'" + 900 / 16 + "em'",
      xxl: "'" + 1044 / 16 + "em'",
      xxxl: "'" + 1168 / 16 + "em'"
    }
  }
};

/***/ }),

/***/ "./node_modules/vt-frontend-engine/app/scripts/principles/responsive/match-viewport.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _matchViewport;

var _mediaQueries = __webpack_require__("./node_modules/vt-frontend-engine/app/scripts/principles/responsive/media-queries.js");

var _mediaQueries2 = _interopRequireDefault(_mediaQueries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _matchViewport(value) {
  if (!value) {
    console.warn('matchViewport: No value provided');
    return false;
  }

  var mediaQuery = _mediaQueries2.default[value];

  if (!mediaQuery) {
    console.warn('matchViewport: Unknown media query');
    return false;
  }

  if (window.matchMedia && window.matchMedia('only all').matches) {
    return window.matchMedia(mediaQuery.query).matches ? true : false;
  } else {
    return true;
  }
}

/***/ }),

/***/ "./node_modules/vt-frontend-engine/app/scripts/principles/responsive/media-queries.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBreakpoint = undefined;

var _breakpoints = __webpack_require__("./node_modules/vt-frontend-engine/app/scripts/principles/responsive/breakpoints.js");

var getBreakpoint = function getBreakpoint(type, name) {
  return !_breakpoints.breakpoints[type] ? undefined : _breakpoints.breakpoints[type][name].replace(/'/g, '');
};

exports.getBreakpoint = getBreakpoint;

exports.default = function () {
  var mediaQueries = {};

  Object.keys(_breakpoints.breakpoints).forEach(function (type) {
    Object.keys(_breakpoints.breakpoints[type]).forEach(function (breakpoint) {
      mediaQueries[type + '-' + breakpoint] = {
        query: '(min-' + type + ':' + getBreakpoint(type, breakpoint) + ')'
      };
    });
  });

  return mediaQueries;
}();

/***/ })

/******/ });


// WEBPACK FOOTER //
// ecom.js